import http from '@/http-common'
import PeopleTab from '@/components/TabSpr.vue'
import FedSelect from '../FederationsListPage.vue'
import InputGroupForm from '@/components/InputGroupForm.vue'
import sportsmanService from '@/utils/services/sportsmanService'
import PeopleSportEdit from "@/views/peoplesport/PeopleSportEdit.vue";
import TabItemsUtils from '@/utils/tabItemsUtils'
import PeopleSportFilter from "@/views/peoplesport/PeopleSportFilter.vue";
import SimpleTab from '@/components/simpletable/SimpleTab.vue'
import SchoolService from '@/utils/services/schoolService'
import global from "@/utils/global"
import TokenService from "@/services/token.service";
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";

export default {
  name: 'people',
  components: {
    FormSelectVue, PeopleTab, FedSelect, InputGroupForm, PeopleSportEdit, PeopleSportFilter,
    SimpleTab
  },
  props: {
    isCalledPeople: {
      type: Boolean,
      default: false,
    },
    columnsPeople: {
      type: Array,
      default: () => [
        {key: 'edit_field', label: '', sortable: false},
        {key: 'federationName', label: 'Федерация', width: '200px'},
        {
          key: 'trainerFlg', label: 'Тренер',
          formatter: (value, key, item) => {
            return item.trainerFlg === true ? 'Да' : 'Нет'
          }
        },
        {
          key: 'teamFlg', label: 'В сборной', width: '80px',
          formatter: (value, key, item) => {
            return item.teamFlg === true ? 'Да' : 'Нет'
          }
        },
        {key: 'structureTeamName', label: 'Состав'},
        {key: 'fio', label: 'ФИО', width: '200px'},
        {
          key: 'birthDay',
          label: 'Дата рождения',
          sortable: true,
          sortByFormatted: true,
          formatter: (value, key, item) => {
            return global.getFormattedDateRU(
                global.stringToDate(item.birthDay)
            )
          },
        },
        {
          key: 'gender', label: 'Пол',
          formatter: (value, key, item) => {
            return item.gender === 'MAN' ? 'МУЖ' : 'ЖЕН'
          }
        },
        {key: 'rankName', label: 'Звание'},
        {key: 'ageKindName', label: 'Категория'},
        {key: 'peoplePostName', label: 'Должность'},
        {key: 'schoolName', label: 'Школа', width: '100px'},
        {key: 'localityName', label: 'Место проживания'},
        {key: 'address', label: 'Адрес', width: '200px'},
        {key: 'disciplineName', label: 'Дисциплина'},
        {key: 'stageTrainingName', label: 'Этап спорт/подготовки"'},
        {key: 'teamName', label: 'Команда'},
        {key: 'trainerFio', label: 'Личный тренер'},
        {key: 'bestEvent', label: 'Результат сезона'},
        {key: 'secondLocalityName', label: 'Двойной зачет'}
      ],
    },
    heightTab: {
      type: String,
      default: "65vh"
    }
  },
  data() {
    return {
      isBusy: false,
      isLoading: false,
      tooltipVisible: false,
      hideTimer: null,
      captionPeople: {
        name: 'Спортсмены',
        nameR: 'Спортсмена'
      },
      items: [],
      captionTable: 'Спортсмены',
      urls: {
        save: '/people/save',
        delete: '/people/delete',
      },
      teamColumns: [
        {key: 'num', label: '№ пп'},
        {key: 'fio', label: 'ФИО'},
        {key: 'edit_field', label: '', sortable: false}
      ],
      filterValue: {
        schoolId: null,
        isTeamFlg: null,
        federationId: null,
        isTrainer: null,
        trainerId: null,
        dat1: null,
        dat2: null
      },
      teamPeoples: [],
      peopleOption: [],
      modalTeamOpened: false,
      showFilter: false,
      modalEditOpened: false,
      trainerList: [],
      schoolList: [],
      fedList: [],
      rankList: [],
      localityList: [],
      secondLocalityList: [],
      ageKindList: [],
      peoplePostList: [],
      stageTrainingList: [],
      structureTeamList: [],
      teamList: [],
      bestEventList: [],
      selectedItem: {
        fio: null,
        birthDay: null,
        gender: null,
        schoolId: null,
        sportKindId: null,
        federationId: null,
        rankId: null,
        locationId: null,
      },
      stacked: {
        flg: false,
        size: 'md'
      },
      // teamFederation_id: 0,
      countRecord: 0,
      filter: "",
      selectMode: 'single',
      selected: [],
      filteredItems: [],
      excel_fields: [
        {field: 'federationName', label: 'Федерация'},
        {
          field: 'trainerFlg', label: 'Сам тренер',
          dataFormat: this.checkYesNo
        },
        {
          field: 'teamFlg', label: 'В сборной',
          dataFormat: this.checkYesNo
        },
        {field: 'structureTeamName', label: 'Состав'},
        {field: 'fio', label: 'ФИО'},
        {field: 'birthDay', label: 'Дата рождения'},
        {field: 'gender', label: 'Пол'},
        {field: 'rankName', label: 'Звание'},
        {field: 'ageKindName', label: 'Категория'},
        {field: 'peoplePostName', label: 'Должность'},
        {field: 'schoolName', label: 'Школа', width: '100px'},
        {field: 'localityName', label: 'Место проживания'},
        {field: 'address', label: 'Адрес', width: '200px'},
        {field: 'disciplineName', label: 'Дисциплина'},
        {field: 'stageTrainingName', label: 'Этап спорт/подготовки"'},
        {field: 'teamName', label: 'Команда'},
        {field: 'trainerFio', label: 'Личный тренер'},
        {field: 'bestEvent', label: 'Результат сезона'},
        {field: 'secondLocalityName', label: 'Двойной зачет'}
      ],
      fileName: 'Список спортсменов',
      selectedFedId: null,
      currentPage: 1,
      perPage: 10,
      isViewBtn: true,
      selectedOpt: null,
      totalFiltered: 0
    }
  },
  created() {
    this.loadItems();
    this.loadFederations()
    this.loadRankList()
    this.loadPeoplePostList()
    this.loadSchoolList()
    this.loadLocalityList()
    this.loadTeamList()
    this.loadAgeKindList()
    this.loadStageTrainings()
    this.loadStructureTeam()
    this.loadBestEventList()
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  computed: {
    computedFields() {
      return this.columnsPeople.map(field => (
          field.width ? {
            ...field,
            thStyle: {width: field.width, minWidth: field.width},
            tdAttr: {style: `max-width: ${field.width}; overflow: hidden;`}
          } : {...field}
      ))
    }
  },
  watch: {
    'filterValue.federationId': function (val) {
      this.loadItems()
    }
  },
  methods: {
    checkYesNo(value) {
      return value === true ? 'Да' : ''
    },
    clearFilter() {
      this.filterValue.federation_id = null;
      this.filter = ''
    },
    phoneFormat(value) {
      return value.map(e => e.phone).join(', ')
    },
    onResize() {
      // Small (sm) <=540px
      if (document.documentElement.clientWidth > global.isMobileWidth()) {
        this.stacked.flg = false
        this.stacked.size = 'sm'
        this.columnsPeople.forEach(function (x) {
          x.class = x.firstClass;
        })
      } else {
        this.stacked.flg = true
        this.stacked.size = 'sm'
        this.columnsPeople.forEach(function (x) {
          x.class = null;
        })
      }
    },
    async loadItems() {
      let vm = this;
      this.isBusy = true;
      try {
        await sportsmanService.getSportsmanList(this.filterValue)
        .then((res) => {
          vm.items = (res && res.data) || [];
          vm.totalFiltered = vm.items.length;
          vm.onFiltered(vm.items)
        })
      } catch (e) {
        console.error(e)
      } finally {
        vm.isBusy = false;
        vm.showFilter = false
      }

      // http.post('/sportsman/list', vm.filterValue)
      // .then((response) => {
      //   console.log(response.data)
      //   vm.items = response.data;
      //   vm.onFiltered(vm.items)
      // })
      // .catch((error) => {
      //   alert(error.response.data)
      // }).finally(() => {
      //   vm.isBusy = false;
      //   vm.showFilter = false
      // });
    },
    showTeam() {
      if (!this.filterValue.federationId || this.filterValue.federationId <= 0) {
        alert('Укажите в фильтре федерацию!');
        return;
      }
      this.peopleOption = this.items.map(function (x) {
        let z = {}
        z.value = x.id;
        z.text = x.fio + (x.birthDay != null ? ' (' + x.birthDay + ' г.р.)' : '')
        return z
      })
      this.loadTeam()
    },
    loadTeam() {
      var vm = this
      http.get('/peoplesport/team?federation_id=' + this.filterValue.federationId)
      .then((response) => {
        vm.teamPeoples = response.data;
        var nn = 1;
        vm.teamPeoples.forEach(function (x) {
          x.num = nn
          nn++
        })
        vm.modalTeamOpened = true
        vm.onFiltered(this.teamPeoples)
        // vm.filterOption()
      })
      .catch((error) => console.log(error.message));
    },
    loadStageTrainings() {
      var vm = this;
      vm.stageTrainingList = []
      http.get('/stage_training/list')
      .then((response) => {
        vm.stageTrainingList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    loadStructureTeam() {
      var vm = this;
      vm.structureTeamList = []
      http.get('/option/structure_team')
      .then((response) => {
        vm.structureTeamList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    loadSchoolList() {
      let vm = this;
      SchoolService.getSchoolList()
      .then((response) => {
        vm.schoolList = response.data;
      })
    },
    loadBestEventList() {
      this.bestEventList = []
      http.get('/best_event/list')
      .then((response) => {
        this.bestEventList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    loadLocalityList() {
      var vm = this;
      vm.localityList = []
      vm.secondLocalityList = []
      http.get('/locality/list')
      .then((response) => {
        vm.localityList = response.data;
        vm.secondLocalityList = response.data
      })
      .catch((error) => console.log(error.message));
    },
    loadTeamList() {
      var vm = this;
      vm.teamList = []
      http.get('/team/list')
      .then((response) => {
        vm.teamList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    loadAgeKindList() {
      var vm = this;
      vm.ageKindList = []
      http.get('/option/ageKind')
      .then((response) => {
        vm.ageKindList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    loadFederations() {
      this.fedList = [];
      let vm = this;
      http.get('/federation/list')
      .then((response) => {
        vm.fedList = response.data
      })
      .catch((error) => console.log(error.message));
    },
    loadRankList() {
      this.rankList = [];
      var vm = this;
      http.get('/rank/list')
      .then((response) => {
        vm.rankList = response.data
      })
      .catch((error) => console.log(error.message));
    },
    loadPeoplePostList() {
      this.peoplePostList = [];
      var vm = this;
      http.get('/people_post/list')
      .then((response) => {
        vm.peoplePostList = response.data
      })
      .catch((error) => console.log(error.message));
    },
    showFilterDialog() {
      this.$refs.peopleFilterForm.showFilterDialog()
    },
    addToTeam() {
      var nn = 1;
      if (this.teamPeoples.length > 0) {
        var teamPeopleLast = this.teamPeoples[this.teamPeoples.length - 1];
        nn = teamPeopleLast.num + 1
      }
      var teamPeople = {id: 0, num: nn}
      var ids = this.teamPeoples.filter(x => x.num !== nn).map(x => x.id);
      if (ids.indexOf(teamPeople.id) >= 0) {
        alert('Пустая строка уже есть в списке!')
      } else {
        this.teamPeoples.push(teamPeople)
        this.onFiltered(this.teamPeoples)
      }
    },
    deleteFromTeam(item) {
      var id = item.id
      const index = this.teamPeoples.map(e => e.id).indexOf(id);
      if (index >= 0) {
        this.teamPeoples.splice(index, 1)
      }
      this.onFiltered(this.teamPeoples)
    },
    onFiltered(filteredItems) {
      this.countRecord = filteredItems.length;
      this.filteredItems = filteredItems
    },
    saveTeam() {
      var vm = this
      var urlSave = '/peoplesport/teamsave?federation_id=' + this.filterValue.federationId
      http.post(urlSave, this.teamPeoples)
      .then((res) => {
        var result = res.data;
        vm.items.forEach(function (people) {
          const index = result.map(e => e.id).indexOf(people.id);
          people.isTeamFlg = index >= 0;
        })
      }).catch(function (error) {
        if (error.response.status === 403) {
          alert("Нет прав!")
        } else {
          alert("Ошибка сохранения на сервере!!!")
        }
      }).finally(() => {
        this.modalTeamOpened = false
      })
    },
    getFederationName() {
      var filterFedId = this.filterValue.federationId;
      var fed = this.fedList.filter(function (x) {
        return x.value === filterFedId
      })
      return fed[0].text;
    },
    getStacked() {
      if (this.stacked.flg) {
        return this.stacked.size;
      } else {
        return false;
      }
    },
    getColor() {
      return "theadColor"
    },
    getPhonesStr(row) {
      return row.phones.map(e => e.phone).join(', ')
    },
    rowSelected(items) {
      this.selected = items;
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
    },
    filterOption(item) {
      var nnRow = item.num
      var ids = this.teamPeoples.filter(x => x.num !== nnRow).map(x => x.id);
      if (ids.indexOf(item.id) >= 0) {
        alert('Указанный спортсмен уже в списке!')
        item.id = 0
      }
    },
    add() {
      if (this.checkRoles()) {
        this.$refs.peopleEditForm.showEditForm(null, this.filterValue.federationId, true)
      } else {
        alert("Недостаточно прав!")
      }
    },
    checkRoles() {
      const userInfo = TokenService.getUser();
      return userInfo.roles.indexOf("ADMIN") >= 0 || userInfo.roles.indexOf("UPDATE_SPORTSMAN") >= 0;
    },
    editItem(rec) {
      if (this.checkRoles()) {
        this.$refs.peopleEditForm.showEditForm(rec.id, this.selectedItem.federationId, false)
      } else {
        alert("Недостаточно прав!")
      }
    },
    copySportsman(item) {
      this.$refs.peopleEditForm.showEditForm(item.id, this.selectedItem.federationId, true)
    },
    saveItem(data, addFlag) {
      TabItemsUtils.updateTableRow(this.items, data, addFlag)
    },
    deleteItem(id_rec) {
      if (this.checkRoles()) {
        this.modalEditOpened = false
        const index = this.items.map(e => e.id).indexOf(id_rec);
        if (index >= 0) {
          this.items.splice(index, 1)
        }
      } else {
        alert("Недостаточно прав!")
      }
    },
    startHideTimer() {
      // Очищаем предыдущий таймер, если он есть
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
      }

      // Устанавливаем таймер на скрытие через 2 секунды
      this.hideTimer = setTimeout(() => {
        this.tooltipVisible = false
      }, 1000)
    }
  },
  beforeDestroy() {
    // Очищаем таймер при уничтожении компонента
    if (this.hideTimer) {
      clearTimeout(this.hideTimer)
    }
  }
}
